import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Spin,
  Select,
  Statistic,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { apiConfig, labelConfig, staticConfig } from "../operations.config";
import dayjs from "dayjs";

import Notiflix from "notiflix";
import { accountStatus } from "../../../components/facilities/AccountFacility";
const dateFormat = "DD-MM-YYYY";

const columns = [
  {
    title: labelConfig.customer,
    dataIndex: "customer",
  },
  {
    title: labelConfig.loanAccountNumber,
    dataIndex: "loanAccountNumber",
    sorter: (a, b) => a.resourceId.localeCompare(b.resourceId),
  },
  {
    title: labelConfig.loanProduct,
    dataIndex: "loanProduct",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },

  {
    title: labelConfig.principal,
    dataIndex: "principal",
  },
];

const ManageLoanDisbursal = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  //   const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [officeData, setOfficeData] = useState([]);
  const [loanList, setLoanList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [currentDate, setCurrentDate] = useState("");

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setLoanList(originalList);
      return;
    }

    const filterBySearch = originalList.filter(
      (item) => item?.customer?.toLowerCase().includes(searchKey)
      //  ||
      // item?.branch?.toLowerCase().includes(searchKey)
    );

    setLoanList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  //END METHODS DECLARED

  useEffect(() => {
    defaultDate();
    getLoans();
  }, []);

  const defaultDate = () => {
    setCurrentDate(dayjs());
  };

  const getLoans = () => {
    const params = {
      limit: 1000,
      sqlSearch: "l.loan_status_id in (100,200)",
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, apiConfig.Loans, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.pageItems.filter(
          (item) =>
            item?.status?.value?.toLowerCase() === accountStatus.approved
        );

        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            customer: element?.clientName ? element?.clientName : "-",
            loanAccountNumber: element?.accountNo ? element.accountNo : "-",
            principal: element?.principal ? element?.principal : "-",
            loanProduct: element?.loanProductName
              ? element?.loanProductName
              : "-",
          });
        });

        setLoanList(tempArray);

        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onSelectItemAction = (selectedKeys, selectedRows) => {
    //HOLD THE OBJECT SELECTED HERE

    setSelectedRowKeys(selectedKeys);
    setSelectedRow(selectedRows);

    [BOM.HasPermission("APPROVE_LOAN") && cnt.RIGHT_DISBURSE_BTN].map(
      (item) => {
        dispatch({
          type: item,
        });
      }
    );
  };

  const handledisbursal = () => {
    let action = "Confirm Disbursal";
    console.log(selectedRow);

    Notiflix.Confirm.show(
      "Are you sure?",
      action,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        let tempBatchArray = selectedRow.map((element, index) => ({
          requestId: index + 1,
          relativeUrl: `loans/${element.id}?command=disburse`,
          method: "POST",
          body: JSON.stringify({
            actualDisbursementDate: BOM.DateTime(currentDate, "only-date"),
            dateFormat: "dd MMMM yyyy",
            locale: "en",
          }),
        }));

        tempBatchArray.session = session;
        tempBatchArray.method = "POST";

        const url = apiConfig.Batches;

        BOM.FetchReqAction(tempBatchArray, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, "Disbursed successfully");
            // navigate("/sms0802");
            dispatch({
              type: cnt.CLEAR_RIGHT_BTN,
            });

            // rightAction(cnt.RIGHT_SEARCH_BTN);

            // getOffice();
            //STOP LOAD
            // Clear selection after successful approval
            setSelectedRowKeys([]);
            setSelectedRow([]);
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDisburse={handledisbursal}>
      <TopContent
        pageTitle={labelConfig.manageLoanDisbursal}
        pageItems={staticConfig.manageLoanDisbursalBreadcrumbItems}
      />

      <Card
        title={`${labelConfig.loan} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Customer..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={loanList}
              columns={columns}
              fileName={"Audit Trail List"}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "checkbox",
              onChange: onSelectItemAction,
              selectedRowKeys: selectedRowKeys, // Controlled selection
            }}
            columns={columns}
            dataSource={loanList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageLoanDisbursal);
